import * as React from "react"
import {Fragment} from "react";
import {Box, Link} from "@mui/material";
import {PopoverSeeker, PopoverSeekerItem} from "@ui-seeker/core";


export default function ScoreColumnPopover({ anchorEl, onClose, dataRow, aggregations, links=[] }) {
	return <PopoverSeeker anchorEl={anchorEl} onClose={onClose}>
		<Box>
			<Box sx={{ mb: 1 }}>
				{ links.map(({ url, target="_blank", icon="external-link", label='', buildUrl=()=>{}, onClick=null }, idx) => {
					const urlTarget = url || buildUrl(dataRow, aggregations)

					return <Fragment key={idx}>
						{ onClick
							? <PopoverSeekerItem icon={icon} label={label} onClick={e => {
								onClose()
								onClick(dataRow, aggregations, e)
							}} />
							: <Link href={urlTarget} target={target} sx={{ cursor: 'pointer' }} onClick={onClose}>
								<PopoverSeekerItem icon={icon} label={label}  />
							</Link>
						}
					</Fragment>
				}) }
			</Box>
		</Box>
	</PopoverSeeker>
}